import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { demoAuthUrl } from "../../config";
import { verifyDemoRedirectUuid } from "../../api/commonApi";

function DemoRouteHandler() {
  let [displayText, updateDisplayText] = useState("Redirecting...");
  async function signInDemoUser(path, id) {
    try {
      let credentialResponse = await verifyDemoRedirectUuid(id, path);
      let { username, password } = credentialResponse.data;
      await Auth.signOut();
      try {
        await Auth.signIn(username.toLowerCase(), password);
      } catch (error) {
        console.log(error);
      }
      window.location.href = `/${path}`;
    } catch (error) {
      console.log(error);
      updateDisplayText("Error");
    }
  }
  useEffect(() => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let path = urlParams.get("path");
    let id = urlParams.get("id");
    signInDemoUser(path, id);
  });

  return <div>{displayText}</div>;
}

export default DemoRouteHandler;
